import { AccountContent } from "@ten24/slatwall-storefront-react-private/global";
import { AccountLayout } from "../../components/Account/AccountLayout/AccountLayout";
import OverviewDraftOrder from "../../components/Account/AccountOverview/OverviewDraftOrders";

const DraftOrderList = () => {
  return (
    <AccountLayout>
      <AccountContent />
      <OverviewDraftOrder />
    </AccountLayout>
  );
};

export default DraftOrderList;
